import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';

import { Box, Flex } from '../../../grid';
import { ByoProductDetailImage } from './product-detail-image';
import { H3, P } from '../../../typography/new';
import { Tags } from '../../../tags';
import { useFeature } from '../../../../hooks/use-feature';

const ByoProductDetailHeader = observer(({ product }) => {
  const { ProductDetailsState } = useRootStore();

  const sizePickerEnabled = useFeature('product-size-picker');
  const showPrice = !sizePickerEnabled || (product.hasOtherSizes !== undefined && !product.hasOtherSizes);

  const { buildYourOwnChoiceStep, isLastStep } = ProductDetailsState;

  return (
    <>
      <ByoProductDetailImage
        isLastStep={isLastStep}
        buildYourOwnChoiceStep={buildYourOwnChoiceStep}
        byoProductType={product.byoType}
      />
      {!isLastStep && (
        <Box p="16px 0 0 16px">
          <H3 mb="8px">{product.name}</H3>
          <P variant="standard" my="8px" color="grey500">
            From
          </P>
          <Flex mb="16px" gap="16px">
            {showPrice && product.prices.formattedPrice && (
              <P variant="standard" fontWeight="bold">
                {product.prices.formattedPrice}
              </P>
            )}
            {product.formattedKilojoules && (
              <P variant="standard" textAlign="center" color="grey500">
                {product.formattedKilojoules}
              </P>
            )}
            {product.formattedDietaryPreferencesList && product.formattedDietaryPreferencesList && (
              <Box>
                <Tags labels={product.formattedDietaryPreferencesList} />
              </Box>
            )}
          </Flex>
        </Box>
      )}
    </>
  );
});

export { ByoProductDetailHeader };
